import { buildAuthentication, clearAuthentication } from "helpers/authenticationHelper";
import useGlobalContext from "hooks/globalData";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  ResponseCode,
  ResponseOfAuthenticationResponse,
} from "services/organizationPortalClient";

export default function LoginComplete() {
  const { authenticationService } = useGlobalContext();
  const { usersUrl } = useGlobalContext();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    async function loginCompleteCallback() {
        const sessionId = searchParams.get("sessionId")!;
        if (sessionId === null) {
            throw new Error("SessionId is null");
        }

        const userResponseRaw: ResponseOfAuthenticationResponse =
        await authenticationService.loginComplete(
          sessionId
        );
      if (
        userResponseRaw.responseCode === ResponseCode.OK &&
        userResponseRaw.data?.result
      ) {
        const userResponse = userResponseRaw.data;
        clearAuthentication();
        buildAuthentication(userResponse);
        window.location.href = userResponseRaw.data.returnUrl || usersUrl();
        return;
      }
    }

    loginCompleteCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
}
